import React, { useState, useRef, useEffect } from 'react';

const AccordionItem = ({ question, answer, isOpen, onClick }) => {
  const contentRef = useRef(null);
  const [height, setHeight] = useState(0);

  useEffect(() => {
    if (contentRef.current) {
      setHeight(contentRef.current.scrollHeight);
    }
  }, []);

  return (
    <button 
      className="flex w-full py-5 px-6 mb-3 items-start justify-between text-left bg-white border-2 border-teal-900 rounded-lg hover:bg-teal-50 transition duration-200" 
      onClick={onClick}
    >
      <div className="w-full">
        <div className="pr-5">
          <h5 className="text-base font-semibold text-teal-900">{question}</h5>
        </div>
        <div 
          ref={contentRef}
          className="overflow-hidden pr-5 duration-500" 
          style={{ height: isOpen ? `${height}px` : '0px' }}
        >
          <p className="text-gray-700 mt-4 text-sm leading-relaxed">{answer}</p>
        </div>
      </div>
      <span className="flex-shrink-0">
        {!isOpen ? (
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M12 5.69995V18.3" stroke="#022C22" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"></path>
            <path d="M5.69995 12H18.3" stroke="#022C22" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"></path>
          </svg>
        ) : (
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M5.69995 12H18.3" stroke="#022C22" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"></path>
          </svg>
        )}
      </span>
    </button>
  );
};

const Accordion = ({ items }) => {
  const [openIndex, setOpenIndex] = useState(null);

  const handleClick = (index) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  return (
    <div className="max-w-4xl mx-auto">
      {items.map((item, index) => (
        <AccordionItem
          key={index}
          question={item.question}
          answer={item.answer}
          isOpen={openIndex === index}
          onClick={() => handleClick(index)}
        />
      ))}
    </div>
  );
};

export default Accordion;
